export const transactionTypes = [
  {
    value: "INCOME",
    label: "Pendapatan",
    debitLabel: "Simpan ke",
    creditLabel: "Diterima dari",
    debitAccounts: ["CASH_AND_BANK", "INVENTORY"],
    creditAccounts: ["INCOME", "OTHER_INCOME"],
  },
  {
    value: "EXPENSE",
    label: "Pengeluaran",
    debitLabel: "Untuk biaya",
    creditLabel: "Diambil dari",
    debitAccounts: [
      "COST_OF_GOODS_SOLD",
      "EXPENSE",
      "OTHER_EXPENSE",
      "INVENTORY",
      "CASH_AND_BANK",
      "ACCOUNTS_RECEIVABLE",
      "FIXED_ASSETS",
    ],
    creditAccounts: [
      "CASH_AND_BANK",
      "INVENTORY",
      "OTHER_CURRENT_ASSETS",
      "FIXED_ASSETS",
      "OTHER_ASSETS",
    ],
  },
  {
    value: "INVESTMENT",
    label: "Tanam Modal",
    debitLabel: "Simpan ke",
    creditLabel: "Modal",
    debitAccounts: ["CASH_AND_BANK"],
    creditAccounts: ["CAPITAL"],
  },
  {
    value: "DIVESTMENT",
    label: "Tarik Modal",
    debitLabel: "Modal",
    creditLabel: "Diambil dari",
    debitAccounts: ["CAPITAL"],
    creditAccounts: ["CASH_AND_BANK"],
  },
  {
    value: "TRANSFER",
    label: "Transfer",
    debitLabel: "Ke",
    creditLabel: "Diambil dari",
    debitAccounts: ["CASH_AND_BANK"],
    creditAccounts: ["CASH_AND_BANK"],
  },
];

export const partnerTransactionTypesOptions = [
  { label: "Accounting", value: "ACCOUNTING" },
  { label: "Cash Book", value: "CASHBOOK" },
];
